import {
  Check,
  FileArchive,
  Gamepad2,
  Globe2,
  Radar,
  RefreshCcw,
  ShieldCheck,
  Sparkles,
  Zap
} from 'lucide-react';

export function DetectionVisual() {
  return (
    <div className="feature-art detection-art" aria-hidden="true">
      <div className="radar-field"><i /><i /><i /><span><Radar size={24} /></span></div>
      <div className="process-pill one"><i className="steam-dot" /><span>Steam</span><small>launcher</small></div>
      <div className="process-pill two active"><i className="game-dot" /><span>Game.exe</span><small>algılandı</small><b><Check size={10} /></b></div>
      <div className="process-pill three"><i className="shield-dot" /><span>Anti-cheat</span><small>korundu</small></div>
    </div>
  );
}

export function FpsVisual() {
  const heights = [34, 48, 42, 66, 52, 76, 58, 84, 72, 88, 68, 81];
  return (
    <div className="feature-art fps-art" aria-hidden="true">
      <div className="fps-game-surface">
        <div className="fps-horizon" />
        <div className="fps-crosshair"><i /><i /></div>
        <div className="fps-counter"><i /><strong>144</strong><span>FPS</span><small>6.9 ms</small></div>
        <div className="frame-chart">{heights.map((height, index) => <i key={index} style={{ height: `${height}%` }} />)}</div>
      </div>
    </div>
  );
}

export function CleanerVisual() {
  return (
    <div className="feature-art cleaner-art" aria-hidden="true">
      <div className="clean-ring"><div><Sparkles size={25} /><strong>4.8</strong><span>GB</span></div></div>
      <div className="clean-list">
        <span><i className="purple"><FileArchive size={12} /></i><b>Geçici dosyalar</b><small>2.1 GB</small></span>
        <span><i className="cyan"><FileArchive size={12} /></i><b>Tarayıcı önbelleği</b><small>1.6 GB</small></span>
        <span><i className="green"><FileArchive size={12} /></i><b>Çökme raporları</b><small>1.1 GB</small></span>
      </div>
    </div>
  );
}

export function RestoreVisual() {
  return (
    <div className="feature-art restore-art" aria-hidden="true">
      <div className="restore-track"><i className="track-fill" /></div>
      <div className="restore-step active"><span><Gamepad2 size={15} /></span><b>Oyun açıldı</b><small>Algılandı</small></div>
      <div className="restore-step active"><span><Zap size={15} /></span><b>Odak uygulandı</b><small>High QoS</small></div>
      <div className="restore-step"><span><RefreshCcw size={15} /></span><b>Geri yükleme</b><small>Otomatik</small></div>
    </div>
  );
}

export function LanguageVisual() {
  return (
    <div className="feature-art language-art" aria-hidden="true">
      <div className="globe-core"><Globe2 size={36} /><strong>20</strong><span>DİL</span></div>
      <span className="language-chip chip-tr">TR</span>
      <span className="language-chip chip-en">EN</span>
      <span className="language-chip chip-de">DE</span>
      <span className="language-chip chip-ja">日本</span>
      <span className="language-chip chip-ar">ع</span>
      <span className="language-chip chip-zh">中</span>
    </div>
  );
}

export function SafetyVisual() {
  return (
    <div className="feature-art safety-art" aria-hidden="true">
      <div className="safety-shield"><ShieldCheck size={42} /><i /></div>
      <div className="safety-code"><span><i /> Defender</span><b>KORUNUYOR</b></div>
      <div className="safety-code"><span><i /> Anti-cheat</span><b>KORUNUYOR</b></div>
      <div className="safety-code"><span><i /> Kişisel dosyalar</span><b>KAPSAM DIŞI</b></div>
    </div>
  );
}
